import { PlayListNodeUploadDto } from "collaboration-service";
import { Button } from "imaginarity-react-ui";
import _ from "lodash";
import React, { useState } from "react";
import { shallowCompare } from "services/Helpers";
import { PlaylistEditState, useSelectorPLE } from "./PlaylistEdit";
import { CurSeqContainer } from "./PlaylistEditClasses";
import PlaylistEditSequenceCurrent from "./PlaylistEditSequenceCurrent";
import { PlaylistEditSequenceLinearSC as T } from "./PlaylistEditSequenceLinearSC";
import { usePLEState } from "./usePLEState";
import { getCurrentPlaylistNode } from "./PlaylistEditLinearNode";

interface PlaylistEditNodeContentsProps {
    node: PlayListNodeUploadDto;
    referenceIds: string[];
    successor: any;
    sel: boolean;
    toggleReferenceId: (id: string) => void;
    toggleByTrainerReferenceId: (id: string) => void;
}

const pleMapper = (state: PlaylistEditState) => ({
    posts: state.posts,
    contents: state.playlist?.contents,
});

const PlaylistEditNodeContents: React.FC<PlaylistEditNodeContentsProps> = ({
    node,
    referenceIds,
    successor,
    sel,
    toggleReferenceId,
    toggleByTrainerReferenceId
}) => {
    const [showContents, setShowContents] = useState(true);
    const { posts, contents } = useSelectorPLE(pleMapper, shallowCompare);

    const s_startNode = usePLEState(x => x.startNode);

    if (!node.referenceIds || node.referenceIds.length === 0) return null;

    return (
        <>
            <Button
                icon={showContents ? "chevron up" : "chevron down"}
                kind="halfTransparentButton"
                floated="right"
                onClick={() => setShowContents((prev) => !prev)}
            />
            {showContents &&
                _.map(node.referenceIds, (refId, j) => {
                    const pc = _.find(posts, (c) => c.id === refId);
                    const needsRef =
                        successor &&
                        (successor.transitionFunction === "ReferenceDone" ||
                            successor.transitionFunction === "ReferenceDoneWithValue");
                    const del = () => {
                        const { curNode, startNode } = getCurrentPlaylistNode(s_startNode, node);
                        if (curNode) {
                            curNode.referenceIds!.splice(j, 1);
                            s_startNode.setValue(startNode);
                        }
                    };
                    const up =
                        j > 0
                            ? () => {
                                const { curNode, startNode } = getCurrentPlaylistNode(s_startNode, node);
                                if (curNode) {
                                    const rIds = _.clone(curNode.referenceIds!);
                                    const x = rIds[j];
                                    rIds[j] = rIds[j - 1];
                                    rIds[j - 1] = x;
                                    curNode.referenceIds = rIds;
                                    s_startNode.setValue(startNode);
                                }

                            }
                            : undefined;
                    const down =
                        node?.referenceIds && j < node.referenceIds?.length - 1
                            ? () => {
                                const { curNode, startNode } = getCurrentPlaylistNode(s_startNode, node);
                                if (curNode) {
                                    const rIds = _.clone(node.referenceIds!);
                                    const x = rIds[j];
                                    rIds[j] = rIds[j + 1];
                                    rIds[j + 1] = x;
                                    curNode.referenceIds = rIds;
                                    s_startNode.setValue(startNode);
                                }

                            }
                            : undefined;
                    const isRef = _.find(referenceIds, (r) => r === refId) !== undefined;
                    const isTrainerRef = _.find(node.byTrainerReferenceIds, (r) => r === refId) !== undefined;
                    const content = _.find(contents, (f) => f.referenceId === refId);
                    if (pc && content)
                        return (
                            <T.NodeItemContainer key={j}>
                                <CurSeqContainer isReference={isRef} color={node.color ?? "@accentGreen"}>
                                    <T.PESCContainer sel={sel}>
                                        <PlaylistEditSequenceCurrent
                                            post={pc}
                                            onSelect={needsRef ? () => toggleReferenceId(refId) : undefined}
                                            onSelectByTrainer={() => toggleByTrainerReferenceId(refId)}
                                            onDelete={del}
                                            needsRef={needsRef}
                                            selected={sel}
                                            isRef={isRef}
                                            isTrainerRef={isTrainerRef}
                                            onUp={up}
                                            onDown={down}
                                            content={content}
                                        />
                                    </T.PESCContainer>
                                </CurSeqContainer>
                            </T.NodeItemContainer>
                        );
                    return <div key={j} />;
                })}
        </>
    );
};

export default PlaylistEditNodeContents;
